import { orange, secondary } from 'styles'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  active: {
    fontWeight: '700',

    '&&': {
      color: orange,
    },
  },
  indicator: {
    '&&': {
      height: '0.25rem',
    },
  },
  root: {
    margin: '0.5rem 1.5rem 0 1.5rem',
    '&&': {
      minHeight: '3rem',
    },
  },
  tab: {
    '&&': {
      color: secondary,
      fontWeight: '700',
      fontSize: '1.5rem',
      textTransform: 'initial',
      padding: '0 1rem',
      minHeight: '3rem',
    },
  },
})
